"use client";

import React from "react";
import { Box } from "@chakra-ui/react";
import Accordion from "../../../components/Accordion";
import Button from "../../../components/Button";
import Markdown from "../../../components/Markdown";
import { Faq } from "../../../graphql/generated/graphql";

type Props = {
  faqs: Faq[];
};

const Faqs: React.FC<Props> = ({ faqs }) => {
  const items = faqs.map(({ id, title, answer }) => ({
    id,
    title,
    content: (
      <Box
        // align with accordion title
        pl={[null, "52px"]}
      >
        <Markdown>{answer}</Markdown>
      </Box>
    ),
  }));

  return (
    <>
      <Accordion multiple maxWidth={800} mt={[6, 10]} items={items} />

      <Button
        asChild
        visual="link"
        color="inherit"
        alignSelf="flex-start"
        fontSize={16}
        mt={6}
      >
        <a href="mailto:tom@zerotofinals.com">
          Unanswered question? Send an email
        </a>
      </Button>
    </>
  );
};

export default Faqs;
